export const ON_SAVE_WAITING_TIME = 0;